module.exports = __webpack_public_path__ + "static/Web_ClusterPacks_Purr-oudlyCanadian-60a4760129478252ceecd96a651cfdf3.jpg";